import { useAuth } from '../../../../contexts/authContext';
// Resolves the authenticated user's tenant id for delivery RPCs. Throws if
// the user isn't authenticated yet — pages should not render delivery
// components above the protected-route boundary, so this throw signals a
// real routing bug rather than a transient state.
export function useTenantId() {
    const { user } = useAuth();
    if (!user?.tenant_id) {
        throw new Error('useTenantId: no tenant on authenticated user');
    }
    return user.tenant_id;
}
